import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import * as XLSX from 'xlsx';
import axios from 'src/app/Service/axios';

interface TransformedData {
  header: string[];
  rows: any[][];
}

@Component({
  selector: 'app-telemetry-can-analyzer',
  templateUrl: './telemetry-can-analyzer.component.html',
  styleUrls: ['./telemetry-can-analyzer.component.css']
})

export class TelemetryCanAnalyzerComponent implements OnInit {
  selectedIds = [];
  tableData: TransformedData;
  filteredData: TransformedData;

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
  })

  public systemStatus = [
    { id: 'bCharge', label: 'درحال شارژ' },
    { id: 'bMove', label: 'درحال حرکت' },
    { id: 'bReady2Move', label: 'آماده حرکت' },
    { id: 'bKey', label: 'سوئیچ باز' },
    { id: 'bCooler', label: 'کولر روشن' },
    { id: 'bHeater', label: 'بخاری روشن' },
    { id: 'bDefrost', label: 'گرم‌کن عقب روشن' },
    { id: 'bBattery', label: 'باتری کمکی ضعیف' }
  ];

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {
    this.getDashboardData()
  }

  async getDashboardData() {
    this._otherService.Showspinner();
    let response = JSON.parse((await axios.post(`CAN_FleetDashboard`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());
    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'CAN_FleetDashboard' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    const transformData = this.transformData(response);
    if (transformData) {
      this.tableData = transformData;
      this.filteredData = this.transformData(response); // Preventing side effects
    }

  }

  transformData(data: any[]): TransformedData | null {
    let transformedOutput: TransformedData | null = null;

    if (!data || data.length === 0) {
      return transformedOutput = null;
    }

    const header = Object.keys(data[0]);
    const rows = data.map(item => {
      return header.map(header => item[header]);
    });

    return transformedOutput = {
      header: header,
      rows: rows,
    };

  }

  hasStatusChecked(item): boolean {
    return this.selectedIds.some((s) =>
      s === item.id
    )
  }

  onCheckboxChange(item: any, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.addToSelected(item);
    } else {
      this.removeFromSelected(item);
    }

  }

  private addToSelected(item: any): void {
    const exists = this.selectedIds.some(selected => selected === item.id);
    if (!exists) {
      this.selectedIds.push(item.id);
      this.transformSelectedAsBoolean()
    }
  }

  private removeFromSelected(item: any): void {
    this.selectedIds = this.selectedIds.filter(selected => selected !== item.id);
    this.transformSelectedAsBoolean()

  }

  private transformSelectedAsBoolean() {
    const ids = this.systemStatus.map((s) => s.id);

    const systemStatusAsBoolean = ids.reduce((acc, item) => {
      const key = item;
      const value = this.selectedIds.includes(item);
      acc[key] = value;
      return acc;
    }, {} as { [key: string]: boolean });

    this.updateTable(systemStatusAsBoolean)

  }

  async updateTable(systemStatus) {
    const model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      ...systemStatus
    }

    this._otherService.Showspinner();
    let response = JSON.parse((await axios.post(`CAN_DataAnalyze`, this._otherService.stringNumberToNumber(model))).data.toString());
    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'CAN_DataAnalyze' } });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    const transformData: TransformedData = this.transformData(response);
    if (transformData) {
      this.tableData = transformData;
      this.filteredData = this.transformData(response); // Preventing side effects
    }

  }

  filterResult(term: string) {
    if (term.length > 1) {
      this.tableData.rows = this.filteredData.rows.filter((el: any) => {
        const unitId = el[0] ? String(el[0]) : '';
        const plate = el[1] ? String(el[1]) : '';
        const vin = el[2] ? String(el[2]) : '';
        return unitId.includes(term) || plate.includes(term) || vin.includes(term);
      });
    } else {
      this.tableData.rows = this.filteredData.rows;
    }
  }

  exportExcel() {
    setTimeout(() => {
      let element = document.getElementById('Export_Excel');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'can تحلیل اطلاعات.xlsx');
    }, 200);
  }




  //   <div [formGroup]="carForm" class="col-auto p-1">
  //     <ng-select class="ng-select" [items]="systemStatus" bindLabel="label" bindValue="id" [multiple]="true"
  //         [searchable]="false" [closeOnSelect]="false" [placeholder]="'وضعیت خودرو'"
  //         formControlName="systemStatus" (change)="onStatusChange($event)">
  //         <ng-template ng-option-tmp let-item="item" let-index="index">
  //             <div class="custom-option-wrapper">
  //                 <label class="custom-checkbox-label">
  //                     <input type="checkbox" [checked]="hasStatusChecked(item)" />
  //                     <span class="option-text">{{ item.label }}</span>
  //                 </label>
  //             </div>
  //         </ng-template>
  //         <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
  //             <div *ngFor="let item of items | slice:0:1" class="ng-value">
  //                 <span class="ng-value-label">{{ item.label }}</span>
  //                 <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
  //             </div>
  //             <div *ngIf="items.length > 1" class="ng-value">
  //                 <span class="ng-value-label">
  //                     {{ items.length - 1 | faNum }}+ مورد
  //                 </span>
  //             </div>
  //         </ng-template>
  //     </ng-select>
  // </div>

}
